import { Box, Button, Heading, Spinner, Text } from '@chakra-ui/react'
import { Icon, Layout } from 'components/atoms'
import { useContractContext } from 'contexts/contract'
import { FormFileDataProps } from 'pages/Contracts/Components/Forms/FormFileData/interfaces'

import React from 'react'
import { ModalContractHandle, ModalContractProps } from '../interface'

const LoadingModal: React.ForwardRefRenderFunction<
    ModalContractProps,
    ModalContractHandle
> = ({
    onCancelForm,
    onSubmit,
    toCorrectContract,
    onInValid,
    isLoading,
    isError,
    typeModal,
    dataError,
    contractResponse
}) => {
    const { setNewContract, setFileData } = useContractContext()
    const isParcialmenteRegistrado =
        contractResponse?.statusContrato === 'PARCIALMENTE_REGISTRADO'
    const isExternalAdditive = typeModal === 'EXTERNAL_ADDITIVE'

    const onCancel = (): void => {
        onCancelForm && onCancelForm()
        onInValid && onInValid()
        onSubmit && onSubmit()
        setNewContract(true)
    }

    const handleCloseAllFlow = (): void => {
        onSubmit && onSubmit()
        setFileData({} as FormFileDataProps)
    }

    const handleCorrectionContract = (): void => {
        onCancelForm && onCancelForm()
        onInValid && onInValid()
        toCorrectContract && toCorrectContract()
    }

    return (
        <Layout
            type="container"
            full
            display="grid"
            gap={10}
            data-testid="modal-container"
        >
            <Layout type="row" data-testid="form-heading">
                <Heading size="md" textAlign={{ sm: 'center' }}>
                    {isExternalAdditive
                        ? 'Validação de Aditivo'
                        : 'Validação de Contrato'}
                </Heading>
            </Layout>

            <Layout
                type="container"
                gap={8}
                gutter={{ y: 1.5 }}
                data-testid="modal-area"
                mt="118px"
                mb="120px"
            >
                {!isLoading ? (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexDirection="column"
                    >
                        <Text as="b">Sincronizando com o DETRAN</Text>
                        <Text>
                            Não saia dessa tela até finalizar a sincronização.
                        </Text>
                        <Spinner
                            mt="32px"
                            thickness="9px"
                            speed="0.65s"
                            emptyColor="gray.200"
                            color="primary"
                            size="xl"
                        />
                    </Box>
                ) : isLoading && isError ? (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexDirection="column"
                        minHeight="145px"
                    >
                        <Icon name="error" size={32} />
                        <Text as="b" mt="24px">
                            {isExternalAdditive
                                ? 'Aditivo recusado'
                                : 'Contrato recusado'}
                        </Text>
                        <Text as="b" mt="24px">
                            Motivo:
                        </Text>
                        <Box
                            display="flex"
                            flexDirection="row"
                            flexWrap="wrap"
                            maxW="53rem"
                            justifyContent="space-evenly"
                        >
                            {dataError?.map((res, key: number) => {
                                return (
                                    <>
                                        <Text fontWeight="400" mt="8px">
                                            {res?.mensagem}
                                        </Text>
                                        {dataError.length > 1 &&
                                        !(key === dataError.length - 1) ? (
                                            <Text
                                                margin="0 0.50rem"
                                                lineHeight="1.8"
                                            >
                                                _
                                            </Text>
                                        ) : (
                                            ''
                                        )}
                                    </>
                                )
                            })}
                        </Box>
                    </Box>
                ) : (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexDirection="column"
                        height="145px"
                    >
                        <Icon name="success" size={32} />
                        <Text as="b" mt="24px">
                            {isParcialmenteRegistrado
                                ? 'Contrato parcialmente registrado!'
                                : isExternalAdditive
                                ? 'Aditivo registrado!'
                                : 'Contrato aprovado!'}
                        </Text>
                        <Text textAlign="center">
                            {isParcialmenteRegistrado
                                ? contractResponse?.mensagemRetorno700
                                : isExternalAdditive
                                ? 'O aditivo foi registrado com sucesso.'
                                : 'Finalize ou adicione um novo contrato.'}
                        </Text>
                    </Box>
                )}
            </Layout>

            <Layout
                type="row"
                gutter={{ y: 1.5 }}
                data-testid="form-fields"
            ></Layout>
            <Layout type="row" data-testid="form-action">
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={6}
                >
                    {typeModal === 'CREATE' && (
                        <Button
                            data-testid="form-action-cancel"
                            colorScheme="primary"
                            variant="outline"
                            isDisabled={!isLoading}
                            onClick={
                                isLoading && isError
                                    ? handleCloseAllFlow
                                    : onCancel
                            }
                        >
                            {isLoading && isError
                                ? 'Cancelar'
                                : 'Novo Contrato'}
                        </Button>
                    )}
                    <Button
                        data-testid="form-action-confirm"
                        colorScheme="primary"
                        type="submit"
                        isDisabled={!isLoading}
                        onClick={
                            isLoading && isError
                                ? handleCorrectionContract
                                : handleCloseAllFlow
                        }
                    >
                        {isLoading && isError ? 'Corrigir' : 'Finalizar'}
                    </Button>
                </Box>
            </Layout>
        </Layout>
    )
}

export default LoadingModal
